import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/react-hooks';
import App from './components/App';
import store from './store';
import ClientService from './services/ClientService.jsx';

const apolloClient = ClientService.client;

const component = (
  <ApolloProvider client={apolloClient}>
    <Provider store={store}>
      <App/>
    </Provider>
  </ApolloProvider>
);

ReactDOM.render(component, document.getElementById('root-view'));
